import type { Dictionary, GetterClass, HighlightsSetup, HighlightsState } from '../../../models'

export class SetupGetter implements GetterClass {
  static execute(this: void, state: HighlightsState): Dictionary<HighlightsSetup> {
    return state.setup
  }
}
